
import axios from 'axios';


// UPLOADS
export const  axios_ficbulletin_bulletinupload = async({lead,formule})=>{
    return await axios.post(`/ficbulletin/bulletinupload/`,{lead,formule},{responseType:'blob'},{headers:{'Accept':'application/json','Content-Type':'application/json'}});
}

export const  axios_ficbulletin_ficupload= async({lead,formule})=>{
    return await axios.post(`/ficbulletin/ficupload/`,{lead,formule},{responseType:'blob'},{headers:{'Accept':'application/json','Content-Type':'application/json'}});
}


export const  axios_ficbulletin_ficbulletinupload= async({lead,formule})=>{
    return await axios.post(`/ficbulletin/ficbulletinupload/`,{lead,formule},{responseType:'blob'},{headers:{'Accept':'application/json','Content-Type':'application/json'}});
}

// TO YOUSIGN 

// export const  axios_ficbulletin_fictoyousign = async({lead,formule})=>{
//     return await axios.post(`/ficbulletin/fictoyousign/`,{lead,formule},{headers:{'Accept':'application/json','Content-Type':'application/json'}});
// } 


// export const  axios_ficbulletin_ficbulletintoyousign = async({lead,formule})=>{
//     return await axios.post(`/ficbulletin/ficbulletintoyousign/`,{lead,formule},{headers:{'Accept':'application/json','Content-Type':'application/json'}});
// }

// export const  axios_ficbulletin_bulletintoyousign = async({lead,formule})=>{
//     return await axios.post(`/ficbulletin/bulletintoyousign/`,{lead,formule},{headers:{'Accept':'application/json','Content-Type':'application/json'}});
// }


// DEV SIGNASSUR
// TO SIGNASSURE

export const  axios_ficbulletin_fictosignassur = async({lead,formule})=>{
    return await axios.post(`/ficbulletin/fictosignassur/`,{lead,formule},{headers:{'Accept':'application/json','Content-Type':'application/json'}});
} 


export const  axios_ficbulletin_ficbulletintosignassur = async({lead,formule})=>{
    return await axios.post(`/ficbulletin/ficbulletintosignassur/`,{lead,formule},{headers:{'Accept':'application/json','Content-Type':'application/json'}});
}

export const  axios_ficbulletin_bulletintosignassur = async({lead,formule})=>{
    return await axios.post(`/ficbulletin/bulletintosignassur/`,{lead,formule},{headers:{'Accept':'application/json','Content-Type':'application/json'}});
}